import Axios from 'axios';
import {
  CREDSYSTEM_LOGIN_REFRESH_TOKEN,
  CREDSYSTEM_LOGIN_TOKEN,
} from '~/credsystem/storage/constants';
import { CredsystemLocalStorage } from '~/credsystem/storage/LocalStorage';
import Env from '~/credsystem/env';

const apiSSOCredSystem = Axios.create({
  baseURL: `https://${Env.CREDSYSTEM_SSO}/`,
  headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
});

apiSSOCredSystem.interceptors.request.use(async (config) => {
  const token = await CredsystemLocalStorage.get(CREDSYSTEM_LOGIN_TOKEN);

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

interface APISuccessResponse {
  access_token: string;
  expires_in: number;
  refresh_token: string;
  refresh_expires_in: number;
  token_type: string;
}

apiSSOCredSystem.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;
    if (error.response.status === 403 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = await CredsystemLocalStorage.get(
        CREDSYSTEM_LOGIN_REFRESH_TOKEN
      );

      if (refreshToken) {
        const body = {
          client_id: 'appmarisa',
          client_secret: Env.CREDSYSTEM_CLIENT_SECRET,
          grant_type: 'refresh_token',
          refresh_token: refreshToken,
        };

        const refreshTokenResponse =
          await apiSSOCredSystem.post<APISuccessResponse>(
            `/auth/realms/marisa/protocol/openid-connect/token`,
            body
          );

        const newAccessToken = refreshTokenResponse.data.access_token;
        const newRefreshToken = refreshTokenResponse.data.refresh_token;

        await CredsystemLocalStorage.multiSet([
          [CREDSYSTEM_LOGIN_TOKEN, newAccessToken],
          [CREDSYSTEM_LOGIN_REFRESH_TOKEN, newRefreshToken],
        ]);

        Axios.defaults.headers.common.Authorization =
          'Bearer ' + newAccessToken;
        return apiSSOCredSystem(originalRequest);
      }

      return Promise.reject('Não há token para atualizacão');
    }
    return Promise.reject(error);
  }
);

export default apiSSOCredSystem;
